module.exports = __webpack_public_path__ + "assets/images/project/kranji-marshes/04.jpg?v=a4c21a94";